"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _makeBatch = _interopRequireDefault(require("../api/makeBatch"));

var _LazyKeyStore = require("../store/LazyKeyStore");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _CompaniesChildrenAPI = _interopRequireDefault(require("./api/CompaniesChildrenAPI"));

var _ActionTypes = require("../actions/ActionTypes");

var emptyParent = function emptyParent() {
  return (0, _immutable.Map)().set('results', (0, _immutable.List)()).set('total', 0);
};

var batchFetch = (0, _makeBatch.default)(function (companyId) {
  return _CompaniesChildrenAPI.default.getChildren(companyId);
}, 'CompaniesChildrenAPI.getChildren');
(0, _LazyKeyStore.registerLazyKeyService)({
  namespace: _ActionNamespaces.COMPANY_CHILDREN,
  fetch: batchFetch
});

var _default = (0, _LazyKeyStore.defineLazyKeyStore)({
  namespace: _ActionNamespaces.COMPANY_CHILDREN,
  idIsValid: function idIsValid(companyId) {
    return typeof companyId === 'string';
  }
}).defineName('CompaniesChildrenStore').defineResponseTo([_ActionTypes.COMPANY_PARENT_ADD_CHILD], function (state, _ref) {
  var parentId = _ref.parentId,
      childId = _ref.childId;
  var parentState = state.get(parentId, emptyParent());
  return state.set(parentId, parentState.set('results', parentState.get('results').push(childId)).set('total', parentState.get('total') + 1));
}).defineResponseTo([_ActionTypes.COMPANY_PARENT_REMOVE_CHILD], function (state, _ref2) {
  var parentId = _ref2.parentId,
      childId = _ref2.childId;
  var parentState = state.get(parentId, emptyParent());
  return state.set(parentId, parentState.set('results', parentState.get('results').filterNot(function (value) {
    return value === childId;
  })).set('total', parentState.get('total') - 1));
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;